<template>
  <div class="scrollbar">
    <div class="mdl-card__title">
    <h4 class="mdl-card__title-text">{{title}}</h4>
    </div>
    <div class="mdl-card__supporting-text" :class="{scrollbar: scroll}">
        {{{text}}}
    </div>
  </div>
</template>
<script>
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  module.exports = {
    vuex: {
      getters: getters
    },
    props: {
      tab: String,
      scroll: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      title: function () {
        return label('delayed.details.label.title.' + this.tab)
      },
      text: function () {
        return label('delayed.details.text.' + this.tab)
      }
    }
  }
</script>

<style scoped>
@media only screen and (max-width: 840px) {
  .mdl-tabs__panel>.scrollbar {
    max-height: 400px;
  }
}
@media only screen and (min-width: 840px){
  .mdl-tabs__panel>.scrollbar {
    max-height: 750px;
  }
}
</style>


// WEBPACK FOOTER //
// DelayedDetails.vue?c3ffe9e6